import React from 'react';
import { problems } from '../data/content';
export function Problem() {
  return <section className="bg-paper py-20 sm:py-24" aria-labelledby="problem-title" style={{
    paddingTop: "18px"
  }} data-id="element-168" data-mp="2pf8r2bovqdol">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-169" data-mp="2bg94d9kxg8v2">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-170" data-mp="2bhtzp1f2fvtz">El costo de preparar todo desde cero</p>
        <h2 id="problem-title" className="mt-4 text-balance text-center font-display text-[2rem] leading-[1.1] text-petrol sm:text-5xl" data-id="element-171" data-mp="21ped1qstqj2r">
          Tu tiempo debería estar en la sesión, <em className="text-terra" data-id="element-172" data-mp="1sp85eljt4dbi">no buscando durante horas</em> qué preguntar después.
        </h2>

        <ul className="mt-12 space-y-3" data-id="element-173" data-mp="1wqtf5y11obhh">
          {problems.map(p => <li key={p} className="rounded-r-xl border-l-4 border-terra-soft bg-cream/70 px-6 py-5 text-lg text-ink-soft" data-id="element-174" data-mp="1wrcz1ka999y5">
              {p}
            </li>)}
        </ul>

        <div className="mt-14 text-center" data-id="element-175" data-mp="1np3m6nril4hl">
          <p className="text-balance font-display text-2xl leading-snug text-petrol sm:text-3xl" style={{
          fontSize: "28px",
          fontWeight: "500",
          borderTopWidth: "0px",
          borderRightWidth: "0px",
          borderBottomWidth: "0px",
          borderLeftWidth: "0px",
          borderColor: "#8DCEFC"
        }} data-id="element-176" data-mp="1ns7vu0nr0sfn">
            Preparar una buena sesión requiere criterio profesional.
          </p>
          <p className="mt-3 text-lg text-ink-mute" data-id="element-177" data-mp="xba7lectm78p">
            Eso no significa que cada vez tengas que empezar desde una página vacía.
          </p>
        </div>
      </div>
    </section>;
}